import { createFileRoute } from "@tanstack/react-router"

import { DashboardOverview } from "@/features/dashboard/components/dashboard-overview"
import { dashboardQueryOptions } from "@/features/dashboard/hooks/use-dashboard"
import type { DashboardRange } from "@/features/dashboard/types"
import { warm } from "@/lib/router/warm"

export const Route = createFileRoute("/_shell/voxlane/")({
  // `range` is optional so plain links to /dashboard need no search; it
  // defaults to 24h everywhere it's read.
  validateSearch: (
    search: Record<string, unknown>
  ): { range?: DashboardRange } =>
    search.range === "7d"
      ? { range: "7d" }
      : search.range === "24h"
        ? { range: "24h" }
        : {},
  loaderDeps: ({ search }) => ({ range: search.range ?? "24h" }),
  // Awaited (bounded): the page paints with its data, not skeletons.
  loader: ({ context: { queryClient }, deps: { range } }) =>
    warm(queryClient, [
      dashboardQueryOptions(range),
    ]),
  component: DashboardRoute,
})

function DashboardRoute() {
  const { range = "24h" } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <DashboardOverview
      range={range}
      onRangeChange={(next) =>
        navigate({ search: { range: next }, replace: true })
      }
    />
  )
}
